import { styled } from "@mui/material/styles";
import {
  Breakpoints,
  Mixins,
  Palette,
  Shadows,
  Theme,
  Transitions,
  ZIndex,
} from "@mui/material";
import { Typography } from "@mui/material/styles/createTypography";
import { SIDEBAR_WIDTH } from "./sidebar";

interface mainProps {
  theme: {
    mixins: Mixins;
    palette: Palette;
    shadows: Shadows;
    transitions: Transitions;
    typography: Typography;
    zIndex: ZIndex;
    unstable_strictMode?: boolean;
    breakpoints: Breakpoints;
  };
}

export const MainComponent = styled("main")(({ theme }: mainProps) => ({
  marginLeft: `${SIDEBAR_WIDTH}px`,
  marginTop: "80px",
  width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
  maxWidth: `calc(100% - ${SIDEBAR_WIDTH}px)`,
  boxSizing: "border-box",
  padding: "0 16px 24px",
  transition: "linear 0.3s",
  overflowX: "hidden",
  [theme.breakpoints.down("md")]: {
    padding: "0 12px 16px",
  },
}));
